import { exportPrcessedOptions } from "../../../lib/constants";
import { unixToPersianDay, unixToPersianTime } from "../../../utils/utils";
import Loading from "../../shared/Loading";
import ValueFinder from "../../shared/ValueFinder";

const ExportCard = ({ item }) => {
  return (
    <div className="bg-glass p-3 flex justify-between items-center    ">
      <div className="text-center ">{item?.export_request?.model}</div>

      <div className="text-center">
        <ValueFinder data={exportPrcessedOptions} title={!!item?.export_request?.zip_link_preview} />
      </div>

      <div className="flex flex-col">
        <div className="text-center">
          {item?.export_request?.zip_link_preview ? (
            <button
              className="w-full flex-center"
              onClick={() =>
                window.open(
                  `${import.meta.env.VITE_STORAGE_ENDPOINT + item?.export_request?.zip_link_preview}`,
                  "_blank",
                )
              }
            >
              {/* Uncomment and use the download icon if needed */}
              <img src={"/images/download.svg"} width={40} height={40} alt="search" />
            </button>
          ) : (
            <div className="">
              <Loading />
            </div>
          )}
        </div>
        <div className="text-center align-middle min-w-[120px] text-[10px] text-neutral-50 ">
          <span>{unixToPersianDay(item?.export_request?.creation_time) ?? "-"}</span> _
          <span>{unixToPersianTime(item?.export_request?.creation_time) ?? "-"}</span>
        </div>
      </div>
    </div>
  );
};

export default ExportCard;
